export interface RouteData {
  name: string
}

export interface BreadcrumbData {
  title: string,
  url: string | RouteData,
  here: boolean
}

export interface BreadcrumbInterface {
  title(): string

  url(): string | RouteData

  here(): boolean
}

export class Breadcrumb implements BreadcrumbInterface {
  protected readonly data: BreadcrumbData

  public constructor(data: BreadcrumbData) {
    this.data = data
  }

  public title(): string {
    return this.data.title
  }

  public url(): string | RouteData {
    return this.data.url
  }

  public here(): boolean {
    return this.data.here
  }
}

export interface BreadcrumbsInterface {
  add(data: BreadcrumbData): void

  items(): Array<BreadcrumbInterface>
}

export class Breadcrumbs implements BreadcrumbsInterface {
  protected _items: Array<BreadcrumbInterface> = []

  public constructor(data: Array<BreadcrumbData> = []) {
    data.forEach(itemData => {this._items.push(new Breadcrumb(itemData))})
  }

  public add(data: BreadcrumbData): void {
    this._items.push(new Breadcrumb(data))
  }

  public items(): Array<BreadcrumbInterface> {
    return this._items
  }
}
